import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})

export class NavMenuComponent implements OnInit {
  constructor(
    private locationStrategy: LocationStrategy,
    private router: Router) { }
 
  hasSiteAccess = false;
  HELP_GUIDES_PATH = '/assets/help/Content/Guides/Dashboard/';
  helpUrl: string;
  showCpiHelp: boolean = false;
  notificationsUrl: string;
  userProfileUrl: string;
  productDropdownUrl: string;

  ngOnInit(): void {
    const baseHref = this.locationStrategy.getBaseHref().replace(/\/+$/, '');
    this.notificationsUrl = `${baseHref}/shared/notifications`;
    this.productDropdownUrl = `${baseHref}/shared/menu`;
    this.userProfileUrl = `${baseHref}/shared/profile`;
    this.hasSiteAccess = true;

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.showCpiHelp = this.router.url.includes('sentinel');
    });
    this.helpUrl = `${this.HELP_GUIDES_PATH}Dashboard_Home.htm`;
  }
}
